// import 'babel-polyfill';
import 'console-polyfill';

import env from '../lib/env';
import appConfig from '../../_buildconfig/appconfig';

console.info('*******************************');
console.info('***** MainEvent Staff App *****');
console.info('*******************************');
console.info(`${env.PACKAGE_NAME} version ${env.FULL_VERSION}`);
console.info(JSON.stringify(env));
console.info(`app config:`);
console.info(JSON.stringify(appConfig));
console.info('*******************************');

// General dependencies
// import 'expose-loader?jQuery!jquery';
import 'expose-loader?exposes[]=$&exposes[]=jQuery!jquery';
